// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".commonText_small[data-v-accb840e]{font-size:14px;line-height:21px}.commonText_medium[data-v-accb840e]{font-size:16px;line-height:24px}.commonText_large[data-v-accb840e]{font-size:18px;line-height:27px}.commonText_extraLarge[data-v-accb840e]{font-size:20px;line-height:30px}.commonText_white[data-v-accb840e]{color:#fff}.commonText_normal[data-v-accb840e]{font-weight:400}.commonText_bold[data-v-accb840e]{font-weight:700}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
